import { styled } from '@mui/material';

const BackImage = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.primary.main,
  display: 'flex',
  flexDirection: 'column',
  height: '100%',
  position: 'relative',

  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

const ContentImage = styled('div')({
  inset: 0,
  position: 'absolute',
  zIndex: 0,
});

const Image = styled('img')({
  height: '100%',
  width: '100%',
  objectFit: 'cover',
});

const HeaderLogo = styled('div')(({ theme }) => ({
  zIndex: 1,
  padding: `${theme.spacing(4)} ${theme.spacing(8)}`,
  borderBottom: `2px solid ${theme.palette.background.default}`,
}));

const QuoteContainer = styled('div')(({ theme }) => ({
  zIndex: 1,
  padding: theme.spacing(8),
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  height: '100%',
  '&::before': {
    content: '""',
    display: 'inline-block',
    backgroundColor: theme.palette.common.white,
    width: '75px',
    height: '4px',
    marginBottom: theme.spacing(3),
    marginTop: `-${theme.spacing(10)}`,
  },
  '& h1': {
    color: 'white !important',
    fontSize: '3rem',
    fontWeight: 800,
    lineHeight: 1.2,
    marginBottom: theme.spacing(4),
  },
  '& h2': {
    color: 'white !important',
    fontSize: '2rem',
    lineHeight: 1.2,
    marginBottom: theme.spacing(2),
  },
  '& p': {
    color: theme.palette.common.white,
    fontSize: '1.5rem',
    fontWeight: 'bold',
  },
}));

export { BackImage, ContentImage, Image, HeaderLogo, QuoteContainer };
